module.exports = __webpack_public_path__ + "static/media/purchases.8dd98f77.svg";